<template>
  <div>
    <v-btn color="primary" @click="apiListaRegistros(0, 0, 1)">Generar credenciales</v-btn>
  </div>
</template>

<script>
import mixin from '../mixins.js'
export default {
  mixins: [mixin],
  data: () => ({
    loading: false,
    datos: [],
    registro: {},
    grado: '',
    asesor: {},
    lista: [],
    deuda: []
  }),
  created () {
    this.initialize()
    if (this.login === false) {
      this.$router.push('/Ingresar')
    }
    this.verRegistro()
    this.listarDeudas(0, 0, 1)
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: 1000,
        idx: idx,
        ord: ord,
        pag: pagina,
        grado: ''
      }
      solicitudApi.datos = datos
      if (this.$route.params.idAlumno !== undefined) {
        solicitudApi.datos.idAlumno = this.$route.params.idAlumno
      }
      const myRequest = new Request(`${process.env.API}inicio.php?mod=ficha&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$router.push('Ingresar')
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            this.loading = false
            this.imprimirCredencial()
          }
        })
    },
    listarDeudas (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: 0,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      if (this.$route.params.idAlumno !== undefined) {
        datos.idAlumno = this.$route.params.idAlumno
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.deuda = datos.d
            this.totalRegistros = this.datos.registros
            this.loading = false
          }
        })
    },
    verRegistro () {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {}
      if (this.$route.params.idAlumno !== undefined) {
        solicitudApi.datos.idAlumno = this.$route.params.idAlumno
      }
      const myRequest = new Request(`${process.env.API}inicio.php?mod=pago&accion=ver`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.lista = datos.d
            this.disabledRegistro = true
          }
        })
    },
    imprimirCredencial () {
      var totalPagar = this.lista.total
      for (var item in this.deuda.data) {
        totalPagar -= this.deuda.data[item].fila[2]
      }
      if (parseFloat(totalPagar) > 0) {
        alert('Debe registrar su pago: Falta S/' + totalPagar)
        return
      }
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {datos: this.datos.data, asesores: this.datos.asesores}
      const myRequest = new Request(`${process.env.API}credencial.php`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.blob())
        .then(fileBlob => {
          var newBlob = new Blob([fileBlob], {type: 'application/pdf'})
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }
          const data = window.URL.createObjectURL(newBlob)
          var link = document.createElement('a')
          link.href = data
          link.target = '_blank'
          link.click()
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Credenciales.vue